export const inputBorder = {
  border: '1px solid #F9C8C5 !important',
  _focus: { border: 'none' },
  borderRadius: '5px',
};
